import { useEffect, useState } from 'react';

const usePermissionChecker = (requiredPermissions) => {
  const [hasRequiredPermissions, setHasRequiredPermissions] = useState(false);

  useEffect(() => {
    const userPermissions = JSON.parse(localStorage.getItem('userPermissions')) || [];
    
    // Se não há permissões requeridas, permite acesso
    if (!requiredPermissions || requiredPermissions.length === 0) {
      setHasRequiredPermissions(true);
      return;
    }
    
    // Verifica se o usuário tem PELO MENOS UMA das permissões requeridas (usando .some())
    const userPermissionsLower = userPermissions.map(p => p.toLowerCase());
    const hasPermissions = requiredPermissions.some(permission => 
      userPermissionsLower.includes(permission.toLowerCase())
    );
    
    setHasRequiredPermissions(hasPermissions);
  }, [requiredPermissions]);

  return hasRequiredPermissions;
};

export default usePermissionChecker;
